<div *ngFor="let section of sectionsmenu" class="inm-expandable__container">
  <a *ngIf="!section.subSection && checkValidLink(section.feature)" #lookerlink
    routerLinkActive="active" class="inm-expandable__title" [routerLink]="[section.path, section.slugid]"
    [routerLinkActiveOptions]="{ exact: false }">{{ section.name }}</a>
</div>
